import React, { useState } from 'react'
import { useParams } from "react-router-dom";

import AgentAddForm from './component/AgentAddForm'
import AgentList from './component/AgentList'

import { PageTitle } from "../../../../_template/layout/core/PageData";

const LiveAssistant = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');

    const agentTitle = [
        {
            title: 'Agents',
            path: loginUserType === 'SA' ? `${company}/agents/` : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];
    const [ agentSearchState, setAgentSearchState ] = useState('');
    const agentSearchHandler = (event) => {
        setAgentSearchState(event.target.value)
    }

    const [isFormSubmited, setIsFormSubmited] = useState(false);
    const formSibmittedHandler = () => {
        setIsFormSubmited(true);
        setIsEditButtonClick(false);
    }
    const refreshSuccessHandler = () => {
        setIsFormSubmited(false)
    }

    const [ totalAgentCount, setTotalAgentCount ] = useState(0);
    const totalAgentCountHandler = (count) => {
        setTotalAgentCount(count)
    }

    const [ agentUpdateData, setAgentUpdateData ] = useState({})
    const agentUpdateDataHandler  = (agentUpdateData) => {
        setAgentUpdateData(agentUpdateData)
    }

    const [ isEditButtonClick, setIsEditButtonClick ] = useState(false);
    const editButtonClickHandler = () => {
        setIsEditButtonClick(true);
    }

    return (
        <>
            <PageTitle breadcrumbs={agentTitle}>Live Assistant</PageTitle>
            <AgentAddForm
                agentSearchInput={agentSearchHandler}
                formSubmited={formSibmittedHandler}
                totalAgentCount={totalAgentCount}
                agentUpdateData={agentUpdateData}
                editButton={isEditButtonClick}
            />
            <AgentList
                agentSearchState={agentSearchState}
                isFormSubmited={isFormSubmited}
                refreshSuccess={refreshSuccessHandler}
                totalAgentCount={totalAgentCountHandler}
                agentUpdateData = {agentUpdateDataHandler}
                editButtonClick = {editButtonClickHandler}
            />
        </>
    )
}

export default LiveAssistant